/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */

import { aggregateProductsQuantities } from "../common/func.util";

export function sortAccessories(accessories) {
  // console.log("sortAccessories", accessories);
  const tmpAccessories = [];
  if (!accessories || accessories.length === 0) return tmpAccessories;

  // Split accessories into 4 groups
  const mandatoryAccessories = accessories.filter((acc) => acc.status === "mandatory");
  const highlyRecommendedAccessories = accessories.filter((acc) => acc.status.includes("Highly"));
  const recommendedAccessories = accessories.filter((acc) => acc.status === "recommended");
  const otherAccessories = accessories.filter(
    (acc) => acc.status !== "mandatory" && !acc.status.includes("Highly") && acc.status !== "recommended"
  );

  // Merge the filtered accessories into a single array
  [mandatoryAccessories, highlyRecommendedAccessories, recommendedAccessories, otherAccessories].forEach(
    (accessoriesToMerged) => {
      accessoriesToMerged.forEach((element) => {
        tmpAccessories.push(element);
      });
    }
  );

  return tmpAccessories;
}

export function addSubAccessories(accessories) {
  // console.log("addSubAccessories", accessories);
  const tmpAccessories = [];
  const subAccessories = accessories.filter((acc) => acc.parentsAccessories && acc.parentsAccessories.length > 0);
  // Adding subs array to all accessories
  accessories.forEach((acc) => tmpAccessories.push({ ...acc, subs: [] }));

  // Looping over all sub accessories
  subAccessories.forEach((subAcc) => {
    const subAccIndex = tmpAccessories.findIndex((acc) => acc.commercialReference === subAcc.commercialReference);
    const parentsAccCr = subAcc.parentsAccessories.split(";");
    // Looping over parent accessories
    parentsAccCr.forEach((parentAccCr) => {
      const parentAccIndex = tmpAccessories.findIndex((acc) => acc.commercialReference === parentAccCr);
      if (parentAccIndex > -1 && subAccIndex > -1) {
        const subAccInParentSubsIndex = tmpAccessories[parentAccIndex].subs.findIndex(
          (acc) => acc.commercialReference === subAcc.commercialReference
        );
        if (subAccInParentSubsIndex <= -1) {
          tmpAccessories[parentAccIndex].subs.push({ ...tmpAccessories[subAccIndex], subs: null });
        }
      }
    });
  });

  return tmpAccessories;
}

export const initDriveAccessories = (driveAccessoriesData, driveInterface) => {
  // console.log("initDriveAccessories", driveAccessoriesData, driveInterface);

  const tmpDriveAccessories = [
    ...driveAccessoriesData.map((driveAccessory) => ({
      ...driveAccessory,
      selected: false,
      quantity: 0
    }))
  ];
  // filter only the unnecessary mandatories
  const unnecessaryMandatories = tmpDriveAccessories.filter(
    (element) =>
      element.status === "mandatory" && !element.accessoryType.toLowerCase().includes(driveInterface.toLowerCase())
  );
  // clean unecessary mandatories
  if (unnecessaryMandatories) {
    unnecessaryMandatories.forEach((unecessaryElement) => {
      const unnecessaryMandatoryIndex = tmpDriveAccessories.findIndex(
        (element) => element.commercialReference === unecessaryElement.commercialReference
      );
      tmpDriveAccessories.splice(unnecessaryMandatoryIndex, 1);
    });
  }
  // flag as selected the first Mandtory
  const firstMandatoryIndex = tmpDriveAccessories.findIndex((element) => element.status === "mandatory");
  if (firstMandatoryIndex > -1) {
    tmpDriveAccessories[firstMandatoryIndex].selected = true;
    tmpDriveAccessories[firstMandatoryIndex].quantity = 1;
  }
  // flag as selected Highly recommended
  tmpDriveAccessories.forEach((element) => {
    if (element.status.includes("Highly")) {
      element.selected = true;
      element.quantity = 1;
    }
  });

  const sortedAccessories = sortAccessories(tmpDriveAccessories);
  const addedSubAccessories = addSubAccessories(sortedAccessories);

  return addedSubAccessories;
};

export const initMotorAccessories = (motorAccessoriesData) => {
  // console.log("initMotorAccessories", driveAccessoriesData, driveInterface);

  const tmpMotorAccessories = [
    ...motorAccessoriesData.map((motorAccessory) => ({
      ...motorAccessory,
      selected: false,
      quantity: 0
    }))
  ];
  // filter only the unnecessary mandatories
  const unnecessaryMandatories = tmpMotorAccessories.filter((element) => element.status === "mandatory");

  // clean unecessary mandatories
  if (unnecessaryMandatories) {
    unnecessaryMandatories.forEach((unecessaryElement) => {
      const unnecessaryMandatoryIndex = tmpMotorAccessories.findIndex(
        (element) => element.commercialReference === unecessaryElement.commercialReference
      );
      tmpMotorAccessories.splice(unnecessaryMandatoryIndex, 1);
    });
  }
  // flag as selected the first Mandtory
  const firstMandatoryIndex = tmpMotorAccessories.findIndex((element) => element.status === "mandatory");
  if (firstMandatoryIndex > -1) {
    tmpMotorAccessories[firstMandatoryIndex].selected = true;
    tmpMotorAccessories[firstMandatoryIndex].quantity = 1;
  }
  // flag as selected Highly recommended
  tmpMotorAccessories.forEach((element) => {
    if (element.status.includes("Highly")) {
      element.selected = true;
      element.quantity = 1;
    }
  });

  const sortedAccessories = sortAccessories(tmpMotorAccessories);
  const addedSubAccessories = addSubAccessories(sortedAccessories);

  return addedSubAccessories;
};

export function gatherRetrofitProductsForBOM(axes) {
  // console.log("gatherRetrofitProductsForBOM", axes);
  const tmpProduct = [];
  axes?.forEach((axis) => {
    const motorReference = axis.bundle?.motorReference;
    const driveReference = axis.bundle?.driveReference;
    const gearboxReference = axis.bundle?.gearboxReference;
    const adaptationKitReference = axis.bundle?.adaptationKitReference;
    const driveAccessories = axis.bundle?.bundleData?.drive?.accessories;
    if (motorReference)
      tmpProduct.push({ commercialReference: motorReference, quantity: 1, axis: axis.id, type: "Motor" });
    if (driveReference)
      tmpProduct.push({ commercialReference: driveReference, quantity: 1, axis: axis.id, type: "Drive" });
    if (gearboxReference)
      tmpProduct.push({ commercialReference: gearboxReference, quantity: 1, axis: axis.id, type: "Gearbox" });
    if (adaptationKitReference)
      tmpProduct.push({ commercialReference: adaptationKitReference, quantity: 1, axis: axis.id, type: "Kit" });
    if (driveAccessories) {
      driveAccessories.forEach((accessory) => {
        if (accessory.quantity > 0)
          tmpProduct.push({
            commercialReference: accessory.commercialReference,
            quantity: accessory.quantity,
            axis: axis.id,
            type: "Accessory"
          });
        if (accessory?.subs) {
          accessory?.subs.forEach((subAccessory) => {
            if (subAccessory.quantity > 0)
              tmpProduct.push({
                commercialReference: subAccessory.commercialReference,
                quantity: subAccessory.quantity,
                axis: axis.id
              });
          });
        }
      });
    }
  });
  return aggregateProductsQuantities(tmpProduct);
}
